<template>
    <div id="dashboard">
        <div class="row topCardGrid">
          <sp-card :valor="informacoesCards.totalMedicamentos" :descricao="$t('graficosSaude.cardNumeroMedicamentos')" 
            :footerText="$t('rodape.estimativa', {fonte: cards.metadados.fonte, data: cards.metadados.data})" :lgGrid="4" :mdGrid="4"></sp-card>
          <sp-card :valor="informacoesCards.totalUnidades" :descricao="$t('graficosSaude.cardNumeroFarmacias')" 
            :footerText="$t('rodape.estimativa', {fonte: cards.metadados.fonte, data: cards.metadados.data})" :lgGrid="4" :mdGrid="4"></sp-card>
          <sp-card :valor="informacoesCards.totalPercClassificacao" :valorProgressBar="parseInt(informacoesCards.totalPerc)" :descricao="$t('graficosSaude.cardNumeroCmm')" 
            :footerText="$t('rodape.estimativa', {fonte: cards.metadados.fonte, data: cards.metadados.data})" :lgGrid="4" :mdGrid="4"></sp-card>
        </div>
        <div class="row grafico-segmentado">
          <div class="flex lg6 md6 xs12">
              <sp-360-panel
                class="chart-widget"
                :title="$t('graficosSaude.donutEstoqueMedicamentos')"
                :tooltipOptions="donutTooltipEstoqueRemedio"
                :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"
              >
                <sp360-chart v-bind:data="chartDataEstoquePorMedicamento" :options="optionsDonutChart" type="donut"/>
              </sp-360-panel>
          </div>
          <div class="flex lg6 md6 xs12">
              <sp-360-panel
                class="chart-widget"
                :title="$t('graficosSaude.donutEstoqueMedicamentosPorUnidade')"
                :tooltipOptions="donutTooltipPorFarmacia"
                :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"
              >
                <sp360-chart v-bind:data="chartDataEstoquePorUnidade" :options="optionsDonutChart" type="donut"/>
              </sp-360-panel>
          </div>
        </div>
        <div class="row">
          <div class="flex md12 xs12">
            <sp-360-panel
                :title="$t('graficosSaude.estoqueMedicamentos')"
                :tooltipOptions="topTooltipOptionsTabela"
                :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">

                <div class="row">
                  <div class="flex xs12 lg6 mb-3">
                    <div
                      class="title title--success mb-2 sliderText"
                      :style="{color: this.$themes.success}"
                    > {{sliderText}} </div>
                    <va-slider
                      range
                      pins
                      :step="10"
                      :min="0"
                      :max="100"
                      color="success"
                      value-visible
                      v-model="valueM"
                      @input="filterByRangeMedicamentos"
                    />
                  </div>

                  <div class="flex xs12 sm6 ">
                    <va-input class=""
                      v-model="termA"
                      placeholder="Pesquisar"
                      removable
                      @input="searchA"
                    >
                      <va-icon name="fa fa-search" slot="prepend" />
                    </va-input>
                  </div>
                </div>

                <sp360-data-table id="tabelaEstoqueMedicamentos" ref="tabelaEstoqueMedicamentos"
                    :data="dadosTabelaEstoqueRemedioFiltrado.data"
                    :fields="tableFieldsEstoqueMedicamentos"
                    :perPage="itemsPerPage"
                    :onEachSide="onEachSide"
                    :dataModeFilterableFields="dataModeFilterableFields"
                    :sortFunctions="sortFunctions"
                    :rowClass="corRowPorPorcentagem"
                    :filterInputShown="true"
                    :striped="false"
                    :clickable="true"
                    @row-clicked="rowMedicamentoClicked"
                    />
            </sp-360-panel>
          </div>
        </div>
        <div class="row">
          <div class="flex md12 xs12">
            <sp-360-panel
                class="chart-widget"
                :title="$t('graficosSaude.estoqueMedicamentosPorUnidade')"
                :tooltipOptions="topTooltipOptionsTabelaPorUnidade"
                :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">

                <div class="row">
                  <div class="flex xs12 lg6 mb-3">
                    <div
                      class="title title--success mb-2 sliderText"
                      :style="{color: this.$themes.success}"
                    > {{sliderText}} </div>
                    <va-slider
                      range
                      pins
                      :step="10"
                      :min="0"
                      :max="100"
                      color="success"
                      value-visible
                      v-model="valueU"
                      @input="filterByRangeUnidade"
                    />
                  </div>

                  <div class="flex xs12 sm6 ">
                    <va-input class=""
                      v-model="termB"
                      placeholder="Pesquisar"
                      removable
                      @input="searchB"
                    >
                      <va-icon name="fa fa-search" slot="prepend" />
                    </va-input>
                  </div>
                </div>

                <sp360-data-table id="tabelaEstoquePorUnidade" ref="tabelaEstoquePorUnidade"
                    :data="dadosTabelaEstoquePorUnidadeFiltrado.data"
                    :fields="tableFieldsEstoquePorUnidade"
                    :perPage="itemsPerPage"
                    :onEachSide="onEachSide"
                    :dataModeFilterableFields="dataModeFilterableFieldsPorUnidade"
                    :sortFunctions="sortFunctionsPorUnidade"
                    :rowClass="corRowPorPorcentagem"
                    :filterInputShown="true"
                    :striped="false"
                    :clickable="true"
                    @row-clicked="rowFarmaciaClicked"
                    />
            </sp-360-panel>
          </div>
        </div>

        <div id="modals">
          <va-modal show.sync="true" ref="modalMedicamentos" :okText="'fechar'" :okClass="'btn btn-primary btn-sm'"
            size="large" v-model="showRemedioModal" :title="'Tabela de Medicamentos em estoque da Unidade selecionada'" :cancelText="''" >
            <template slot="default">
              <va-input class=""
                v-model="termModalMed"
                placeholder="Pesquisar"
                removable
                @input="pesquisar"
              >
                <va-icon name="fa fa-search" slot="prepend" />
              </va-input>
              <sp360-data-table id="tableMedicamentos" ref="tableMedicamentos"
                :title="unidadeSelecionada"
                :data="tableMedicamentos.dadosFiltrados.data"
                :fields="tableMedicamentos.fields"
                :perPage="itemsPerPage"
                :onEachSide="onEachSide"
                dataModeFilterableFields=""
                :sortFunctions="tableMedicamentos.sortFunctions"
                :filterInputShown="true"/>
            </template>
          </va-modal>
          <va-modal show.sync="true" ref="modalFarmacias" :okText="'fechar'" :okClass="'btn btn-primary btn-sm'"
            size="large" v-model="showFarmaciaModal" :title="'Tabela de Unidades com estoque do Medicamento selecionado'" :cancelText="''" >
            <template slot="default">
              <va-input class=""
                v-model="termModalFar"
                placeholder="Pesquisar"
                removable
                @input="pesquisar"
              >
                <va-icon name="fa fa-search" slot="prepend" />
              </va-input>
              <sp360-data-table id="tableFarmacias" ref="tableFarmacias"
                :title="medicamentoSelecionado"
                :data="tableFarmacias.dadosFiltrados.data"
                :fields="tableFarmacias.fields"
                :perPage="itemsPerPage"
                :onEachSide="onEachSide"
                dataModeFilterableFields=""
                :sortFunctions="tableFarmacias.sortFunctions" :filterInputShown="true"/>
            </template>
          </va-modal>
        </div>

      </div>
</template>

<script>
import _ from 'lodash'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Constantes from '@/utils/ConstantesGlobais'
import Donut from '@/components/statistics/charts/GraficoDonut.vue'
import CorUtils from '@/utils/CorUtils'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'

export default {
  name: 'estoque-medicamentos',
  components: {
    Donut,
    SpCard,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
  },
  data () {
    return {
      valueM: [0, 100],
      valueU: [0, 100],
      cards: {
        metadados: {
          fonte: '',
          data: ''
        }
      },
      termA: null,
      termB: null,
      termMedicamentos: '',
      termUnidade: '',
      progressKey: 1,
      informacoesCards: { totalMedicamentos: 0, totalUnidades: 0, totalPerc: 0, totalPercString: '' },
      chartDataEstoquePorMedicamento: {},
      chartDataEstoquePorUnidade: {},
      cores: _.shuffle(CorUtils.getVetorCoresPrimaria()),
      coresTabela: [CorUtils.getCorPorNomeSp360(CorUtils.VERMELHO_MEDIO), CorUtils.getCorPorNomeSp360(CorUtils.AMARELO_MEDIO), CorUtils.getCorPorNomeSp360(CorUtils.VERDE_MEDIO), CorUtils.getCorPorNomeSp360(CorUtils.AZUL_GLAUCO_ESCURO)],
      optionsDonutChart: {},
      donutTitleEstoqueRemedio: '',
      donutTitlePorFarmacia: '',
      topTooltipOptionsTabela: {},
      topTooltipOptionsTabelaPorUnidade: {},
      donutTooltipEstoqueRemedio: '',
      donutTooltipPorFarmacia: '',
      onEachSide: 1,
      dadosTabelaEstoqueRemedio: {
        'data': [],
      },
      dadosTabelaEstoqueRemedioFiltrado: {
        'data': [],
      },
      dadosTabelaEstoquePorUnidade: {
        'data': [],
      },
      dadosTabelaEstoquePorUnidadeFiltrado: {
        'data': [],
      },
      itemsPerPage: Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.TAMANHO_TABELAS,

      tableFieldsEstoqueMedicamentos: [
        {
          name: 'medicamento',
          sortField: 'medicamento',
          title: this.$t('graficosSaude.tableFields.medicamento'),
          width: '54%',
        },
        {
          name: 'cmm',
          sortField: 'cmm',
          title: this.$t('graficosSaude.tableFields.cmm'),
          callback: MetodosGlobais.thousandSeparator,
          width: '6%',
        },
        {
          name: 'estoque',
          sortField: 'estoque',
          title: this.$t('graficosSaude.tableFields.estoque'),
          callback: MetodosGlobais.thousandSeparator,
          width: '6%',
        },
        {
          name: 'cobertura_rede_dias',
          sortField: 'cobertura_rede_dias',
          title: this.$t('graficosSaude.tableFields.cobertura_rede_dias'),
          callback: MetodosGlobais.thousandSeparator,
          width: '6%',
        },
        {
          name: 'presenca_farmacias',
          sortField: 'presenca_farmacias',
          title: this.$t('graficosSaude.tableFields.presenca_farmacias'),
          callback: MetodosGlobais.thousandSeparator,
          width: '6%',
        },
        {
          name: 'perc_estoque',
          sortField: 'perc_estoque',
          title: this.$t('graficosSaude.tableFields.perc_estoque'),
          callback: function (x) { return MetodosGlobais.formataPercentual(x) },
          width: '6%',
        },

      ],
      tableFieldsEstoquePorUnidade: [
        {
          name: 'unidade',
          sortField: 'unidade',
          title: this.$t('graficosSaude.tableFields.unidade'),
          width: '76%',
        },
        {
          name: 'id_sub',
          sortField: 'id_sub',
          title: 'subPrefeitura',
          callback: function (x) {
            var a = SPMapaNomes.find(e => {
              if (e.id === x) {
                return e
              };
            })
            return a ? a.nome : 'não encontrado'
          },
          width: '12%',
        },
        {
          name: 'cmm',
          sortField: 'cmm',
          title: this.$t('graficosSaude.tableFields.cmm'),
          callback: MetodosGlobais.thousandSeparator,
          width: '6%',
        },
        {
          name: 'perc_estoque',
          sortField: 'perc_estoque',
          title: this.$t('graficosSaude.tableFields.perc_estoque_medicamento'),
          callback: function (x) { return MetodosGlobais.formataPercentual(x) },
          width: '6%',
        },
      ],
      dataModeFilterableFields: ['medicamento'],
      sortFunctions: {
        'medicamento': MetodosGlobais.ordenaTabela,
        'cmm': MetodosGlobais.ordenaTabelaParseInt,
        'estoque': MetodosGlobais.ordenaTabelaParseInt,
        'cobertura_rede_dias': MetodosGlobais.ordenaTabelaParseInt,
        'presenca_farmacias': MetodosGlobais.ordenaTabelaParseInt,
        'perc_estoque': MetodosGlobais.ordenaTabelaParseFloat,
      },
      dataModeFilterableFieldsPorUnidade: ['unidade', 'id_sub'],
      sortFunctionsPorUnidade: {
        'id_sub': MetodosGlobais.ordenaTabela,
        'unidade': MetodosGlobais.ordenaTabela,
        'cmm': MetodosGlobais.ordenaTabelaParseInt,
        'perc_estoque': MetodosGlobais.ordenaTabelaParseFloat,
      },
      sliderText: 'Porcentagem de Estoque (%)',
      // modals
      showRemedioModal: false,
      showFarmaciaModal: false,
      tableMedicamentos: {
        'data': [],
        dadosFiltrados: {
          'data': [],
        },
        fields: [
          {
            name: 'medicamento',
            sortField: 'medicamento',
            title: this.$t('graficosSaude.tableFields.medicamento'),
          },
          {
            name: 'estoque',
            sortField: 'estoque',
            title: 'ESTOQUE', // TODO: adicionar no graficosSaude.tableFields
            callback: MetodosGlobais.thousandSeparator,
            width: '12%',
          },
          {
            name: 'cmm',
            sortField: 'cmm',
            title: this.$t('graficosSaude.tableFields.cmm'),
            callback: MetodosGlobais.thousandSeparator,
            width: '12%',
          },
        ],
        sortFunctions: {
          'medicamento': MetodosGlobais.ordenaTabela,
          'estoque': MetodosGlobais.ordenaTabelaParseFloat,
          'cmm': MetodosGlobais.ordenaTabelaParseInt,
        },
      },
      tableFarmacias: {
        'data': [],
        dadosFiltrados: {
          'data': [],
        },
        fields: [
          {
            name: 'unidade',
            sortField: 'unidade',
            title: this.$t('graficosSaude.tableFields.unidade'),
            width: '70%',
          },
          {
            name: 'id_sub',
            sortField: 'id_sub',
            title: 'subPrefeitura',
            callback: function (x) {
              var a = SPMapaNomes.find(e => {
                if (e.id === x) {
                  return e
                };
              })
              return a ? a.nome : 'não encontrado'
            },
            width: '20%',
          },
          {
            name: 'estoque',
            sortField: 'estoque',
            title: 'ESTOQUE', // TODO: adicionar no graficosSaude.tableFields
            callback: MetodosGlobais.thousandSeparator,
            width: '12%',
          },
          {
            name: 'cmm',
            sortField: 'cmm',
            title: this.$t('graficosSaude.tableFields.cmm'),
            callback: MetodosGlobais.thousandSeparator,
            width: '6%',
          },
        ],
        sortFunctions: {
          'medicamento': MetodosGlobais.ordenaTabela,
          'cmm': MetodosGlobais.ordenaTabelaParseInt,
          'estoque': MetodosGlobais.ordenaTabelaParseFloat,
        },
      },
      unidadeSelecionada: '',
      medicamentoSelecionado: '',
      dadosFiltrados: {
        'data': [],
      },
      termModalFar: '',
      termModalMed: '',
    }
  },
  created () {
    Promise.all([
      this.$store.dispatch('saude/buscarEstoqueDeRemedios'),
      this.$store.dispatch('saude/buscarEstoqueDeRemediosPorUnidade'),
    ])
      .then(
        (respostas) => {
          this.$emit('updated', new Date())
          this.dadosTabelaEstoqueRemedio.data = respostas[0].data.data // ordenar por ordem crescente e por no max e min no slider
          this.dadosTabelaEstoqueRemedioFiltrado.data = respostas[0].data.data
          this.updateTableEstoqueRemedio(this.dadosTabelaEstoqueRemedio)

          this.dadosTabelaEstoquePorUnidade.data = respostas[1].data.data
          this.dadosTabelaEstoquePorUnidadeFiltrado.data = respostas[1].data.data
          this.updateTableEstoquePorUnidade(this.dadosTabelaEstoquePorUnidade)

          let graficoRoscaEstoqueMedTot = this.calcularRangeCriticidadeETotalizador(this.dadosTabelaEstoqueRemedio.data)
          let graficoRoscaEstoqueUniTot = this.calcularRangeCriticidadeETotalizador(this.dadosTabelaEstoquePorUnidade.data)
          this.optionsDonutChart = this.getOptionDonutChart()
          this.chartDataEstoquePorUnidade = this.populateDonutChart(graficoRoscaEstoqueMedTot[0])
          this.chartDataEstoquePorMedicamento = this.populateDonutChart(graficoRoscaEstoqueUniTot[0])

          this.cards.metadados.fonte = respostas[0].data.sigla_orgao 
          this.cards.metadados.data = MetodosGlobais.dataParaMesExtensoAno(MetodosGlobais.formataDataParaStringDataLocal(new Date(respostas[0].data.data_referencia_dado)))

          this.informacoesCards.totalMedicamentos = graficoRoscaEstoqueMedTot[1].total
          this.informacoesCards.totalUnidades = graficoRoscaEstoqueUniTot[1].total
          this.informacoesCards.totalPerc = graficoRoscaEstoqueUniTot[1].totalPerc
          this.informacoesCards.totalPercClassificacao = graficoRoscaEstoqueUniTot[1].totalPercClassificacao

          //{fonte: fonte, data: dataRef}
          //:footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"
          this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
          this.dataRef = MetodosGlobais.formataDataParaStringDataLocal(new Date(respostas[0].data.data_referencia_dado))
          this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })
        }
      )
      .catch(
        (error) => {
          console.error(error)
        })

    this.topTooltipOptionsTabela = { content: this.$t('graficosSaude.tooltipGraficoEstoqueMedicamentos'), placement: 'bottom', classes: 'va-tooltip tooltip vuestic-tooltip customTooltip' }
    this.topTooltipOptionsTabelaPorUnidade = { content: this.$t('graficosSaude.tooltipGraficoEstoqueMedicamentosPorUnidade'), placement: 'bottom', classes: 'va-tooltip tooltip vuestic-tooltip customTooltip' }
    this.donutTooltipEstoqueRemedio = { content: this.$t('graficosSaude.tooltipDonutEstoqueMedicamentos'), placement: 'bottom', classes: 'va-tooltip tooltip vuestic-tooltip customTooltip' }
    this.donutTooltipPorFarmacia = { content: this.$t('graficosSaude.tooltipDonutEstoqueMedicamentosPorUnidade'), placement: 'bottom', classes: 'va-tooltip tooltip vuestic-tooltip customTooltip' }
  },

  computed: {
    filtrarMedicamento () {
      let a = []
      a = this.filterByValue(this.dadosTabelaEstoqueRemedio.data, this.termMedicamentos)
      return a.length ? a : this.dadosTabelaEstoqueRemedio.data
    },
    filtrarUnidades () {
      let a = []
      a = this.filterByValue(this.dadosTabelaEstoquePorUnidade.data, this.termUnidade)
      return a.length ? a : this.dadosTabelaEstoquePorUnidade.data
    },
  },

  methods: {
    pesquisar: _.debounce(function (term) {
      let refTabela
      let tabela
      if (this.showRemedioModal) {
        refTabela = this.$refs.tableMedicamentos
        tabela = this.tableMedicamentos
      }
      if (this.showFarmaciaModal) {
        refTabela = this.$refs.tableFarmacias
        tabela = this.tableFarmacias
      }

      let a = []
      if ((!Number.isNaN(parseInt(term))) && term != '') {
        a = refTabela.filterByNumber(tabela.data, term)
      } else {
        a = refTabela.filterByString(tabela.data, term)
      }

      tabela.dadosFiltrados.data = a

      this.$set(tabela.dadosFiltrados, 'data', _.orderBy(tabela.dadosFiltrados.data, 'cmm', ['desc']))
    }, 400),

    searchA: _.debounce(function (term) {
      this.termMedicamentos = term
      this.valueM = [0, 100]
      let a = []

      if ((!Number.isNaN(parseInt(term))) && term != '') {
        a = this.$refs.tabelaEstoqueMedicamentos.filterByNumber(this.dadosTabelaEstoqueRemedio.data, term)
      } else {
        a = this.$refs.tabelaEstoqueMedicamentos.filterByString(this.dadosTabelaEstoqueRemedio.data, this.termMedicamentos)
      }

      this.dadosTabelaEstoqueRemedioFiltrado.data = a
      this.updateTableEstoqueRemedio(this.dadosTabelaEstoqueRemedioFiltrado)
    }, 400),

    searchB: _.debounce(function (term) {
      this.termUnidade = term
      this.valueU = [0, 100]
      let a = []

      if ((!Number.isNaN(parseInt(term))) && term != '') {
        a = this.$refs.tabelaEstoquePorUnidade.filterByNumber(this.dadosTabelaEstoquePorUnidade.data, term)
      } else {
        a = this.$refs.tabelaEstoquePorUnidade.filterByString(this.dadosTabelaEstoquePorUnidade.data, this.termUnidade)
      }

      this.dadosTabelaEstoquePorUnidadeFiltrado.data = a
      this.updateTableEstoquePorUnidade(this.dadosTabelaEstoquePorUnidadeFiltrado)
    }, 400),

    rowFarmaciaClicked (item, index, event) {
      this.getMedicamentosDaFarmacia(item['cnes'])
      let sub = SPMapaNomes.find(e => { return (e.id === item.id_sub) ? e.nome : '' })
      this.unidadeSelecionada = item.unidade + ' - ' + sub.nome
      this.openModalMedicamentos()
    },

    rowMedicamentoClicked (item, index, event) {
      this.getFarmaciasDoMedicamento(item['id_medicamento'])
      let sub = SPMapaNomes.find(e => { return (e.id === item.id_sub) ? e.nome : '' })
      this.medicamentoSelecionado = item.medicamento
      this.openModalFarmacias()
    },

    openModalMedicamentos (event) {
      this.showRemedioModal = !this.showRemedioModal
    },
    openModalFarmacias (event) {
      this.showFarmaciaModal = !this.showFarmaciaModal
    },

    filterByRangeMedicamentos () {
      this.termMedicamentos = ''
      let a = []
      a = this.$refs.tabelaEstoqueMedicamentos.filterByRange(this.dadosTabelaEstoqueRemedio.data, this.valueM, 'perc_estoque')
      this.dadosTabelaEstoqueRemedioFiltrado.data = a.length ? a : this.dadosTabelaEstoqueRemedio.data
      this.updateTableEstoqueRemedio(this.dadosTabelaEstoqueRemedioFiltrado)
    },

    filterByRangeUnidade () {
      this.termUnidade = ''
      let a = []
      a = this.$refs.tabelaEstoquePorUnidade.filterByRange(this.dadosTabelaEstoquePorUnidade.data, this.valueU, 'perc_estoque')
      this.dadosTabelaEstoquePorUnidadeFiltrado.data = a.length ? a : this.dadosTabelaEstoquePorUnidade.data
      this.updateTableEstoquePorUnidade(this.dadosTabelaEstoquePorUnidadeFiltrado)
    },

    filterByValue (array, string) {
      return array.filter((obj) => {
        return Object.keys(obj).reduce((acc, curr) => {
          if (typeof obj[curr] === 'string') {
            string.trim()
            return acc || obj[curr].toLowerCase().includes(string.trim().toLowerCase())
          }
          if (typeof obj[curr] === 'number') {
            let a = _.find(SPMapaNomes, (e) => { return (e.id === obj[curr] && e.nome === string) && e.nome })
            if (a) return acc || a
            return acc || obj[curr] <= parseInt(string)
          }
        }, false)
      })
    },

    getClassificadorPerc (perc) {
      if (perc >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.IDEAL) return 'Ideal'
      if (perc >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.BOM) return 'Bom'
      if (perc >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.REGULAR) return 'Regular'
      if (perc >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.CRITICO) return 'Crítico'
    },
    forceReRenderProgress () {
      this.progressKey += 1
    },
    updateTableEstoqueRemedio (dados) {
      this.$set(this.dadosTabelaEstoqueRemedioFiltrado, 'data', _.orderBy(dados.data, 'cmm', ['desc']))
    },
    updateTableEstoquePorUnidade (dados) {
      dados.data.forEach(e => {
        (e.id_sub)
      })
      this.$set(this.dadosTabelaEstoquePorUnidadeFiltrado, 'data', _.orderBy(dados.data, 'cmm', ['desc']))
    },
    corRowPorPorcentagem (dataItem, index) {
      let val = parseFloat(dataItem.perc_estoque)
      if (val > Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.IDEAL) {
        return 'tabelaRemedioCorIdeal'
      } else if (val > Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.BOM) {
        return 'tabelaRemedioCorBom'
      } else if (val > Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.REGULAR) {
        return 'tabelaRemedioCorRegular'
      } else {
        return 'tabelaRemedioCorCritico'
      }
    },
    simpleDataset (dados, backgroundColor, borderColor) {
      let chartData = { labels: [], datasets: [] }
      let dataset = { data: [], backgroundColor: [] }

      for (let x = 0; x < dados.length; x++) {
        const element = dados[x]
        if (element.quantidade > 0) {
          chartData.labels.push(element.nome)
          dataset.data.push(element.quantidade)
          dataset.backgroundColor.push(backgroundColor[x])
        }
      }

      dataset.borderColor = borderColor

      chartData.datasets.push(dataset)

      return chartData
    },
    getOptionDonutChart () {
      return {
        responsive: true,
        title: {
          display: false,
          text: '',
        },
        tooltips: {
          intersect: true,
          callbacks: {
            label: function (tooltipItem, data) {
              var dataLabel = data.labels[tooltipItem.index]
              var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              return (dataLabel += value)
            },
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 25,
            bottom: 0,
          },
        },
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = (value * 100 / sum).toFixed(2) + '%'
              // TODO: mudar para um método global
              return percentage.replace('.', ',')
            },
            font: {
              size: 16,
            },
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
            anchor: 'end',
            align: 'end',
            color: '#000',
            display: 'auto',
          },
        },
      }
    },
    populateDonutChart (dados) {
      let palette = this.$store.getters.palette
      return this.simpleDataset(dados, this.coresTabela, palette.transparent)
    },
    /* Calcula para o estoque de remédios e as farmácias em qual range de criticidade que se encontra */
    calcularRangeCriticidadeETotalizador (vetorDados) {
      let indices = [
        { nome: this.$t('graficosSaude.critico'), quantidade: 0 },
        { nome: this.$t('graficosSaude.regular'), quantidade: 0 },
        { nome: this.$t('graficosSaude.bom'), quantidade: 0 },
        { nome: this.$t('graficosSaude.ideal'), quantidade: 0 },
      ]

      let totalizador = { total: 0, totalPerc: 0 }

      for (let unidade of vetorDados) {
        let percentual = parseFloat(unidade.perc_estoque)
        if (percentual >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.IDEAL) indices[3].quantidade++
        else if (percentual >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.BOM) indices[2].quantidade++
        else if (percentual >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.REGULAR) indices[1].quantidade++
        else indices[0].quantidade++
        totalizador.total++
        totalizador.totalPerc += unidade.perc_estoque
      }
      totalizador.totalPerc /= totalizador.total
      totalizador.totalPercClassificacao = this.getClassificadorPerc(totalizador.totalPerc)
      return [indices, totalizador]
    },

    metodox () {
      return null
    },

    getMedicamentosDaFarmacia (cnes) {
      this.$store.dispatch('saude/buscarEstoquePorRemediosPorUnidade', { cnes: cnes })
        .then((res) => {
          this.tableMedicamentos.data = _.orderBy(res.data.data, 'cmm', ['desc'])
          this.tableMedicamentos.dadosFiltrados.data = _.orderBy(res.data.data, 'cmm', ['desc'])
        })
    },

    getFarmaciasDoMedicamento (id_medicamento) {
      this.$store.dispatch('saude/buscarEstoquePorRemediosPorUnidade', { idMedicamento: id_medicamento })
        .then((res) => {
          this.tableFarmacias.data = _.orderBy(res.data.data, 'cmm', ['desc'])
          this.tableFarmacias.dadosFiltrados.data = _.orderBy(res.data.data, 'cmm', ['desc'])
        })
    },

  },
}
</script>

<style lang="scss">
@import "@/sass/_colors.scss";

$font-size : 1rem;

.tabelaRemedioCorIdeal {
    background-color: $azul-glauco-escuro !important;
    color: white;
     td {
          // border-style: solid;
          // border-width: 2px;
          // border-color: black;
          padding: 0.1rem;
          font-size: $font-size;
      }
}

.tabelaRemedioCorBom {
    background-color: $verde-medio !important;
    color: white;

  td {
        // border-style: solid;
        // border-width: 2px;
        // border-color: black;
        padding: 0.1rem;
        font-size: $font-size;
    }
}

.tabelaRemedioCorRegular {
    background-color: $amarelo-medio !important;
    color: $black;

  td {
        // border-style: solid;
        // border-width: 2px;
        // border-color: black;
        padding: 0.1rem;
        font-size: $font-size;
    }
}

.tabelaRemedioCorCritico {
    background-color: $vermelho-medio !important;
    color: white;

  td {
        // border-style: solid;
        // border-width: 2px;
        // border-color: black;
        padding: 0.1rem;
        font-size: $font-size;
    }
}

</style>

<style lang="scss" scoped>
@import "@/sass/_colors.scss";

.table-header-active {
  thead tr {
    color: black;
  }
}

th.sortable:hover {
  color: $cinza-medio !important;
}

.customTooltip {
    .tooltip-inner {
        border-radius: 16px;
        padding: 5px 10px 4px;
        text-align: left;
      }
}

.va-chart {
  max-height: 25rem
}

.stats{
  width: 100%;
}

.stats-number{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.sliderText{
  font-size: 0.6rem;
  padding-left:3%;
}

.va-modal{
  width: 80rem;;
}
</style>
